import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../../Infra/display-name";
import { FeatureListSearchFieldWrap, FeatureListSearchInput } from "./GlobalAdminFeatureEnablement.styles";
export const FeatureEnablementSearchInput = observer(({ value, placeholder, disabled, onChange }) => {
    return (_jsx(FeatureListSearchFieldWrap, { children: _jsx(FeatureListSearchInput, { type: "search", value: value, placeholder: placeholder, disabled: disabled, onChange: (event) => onChange(event.target.value) }) }));
});
addDisplayName(FeatureEnablementSearchInput, "FeatureEnablementSearchInput");
